<template>
    <div class="modal d-block" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ appDisplayName }} Help</h5>
                </div>
                <div class="modal-body">
                    <div class="row text-center">
                        <div v-if="showCallMeBtn" class="col">
                            <a @click.prevent="openCallMe" href="#">
                                <div class="font-22"><i class="fal fa-phone"></i></div>
                                Call me
                            </a>
                        </div>
                        <div v-if="showGetDemoBtn" class="col">
                            <a @click.prevent="openGetADemo" href="#">
                                <div class="font-22"><i class="fal fa-desktop"></i></div>
                                Get a demo
                            </a>
                        </div>
                        <div class="col">
                            <a :href="supportUrl" target="_blank">
                                <div class="font-22"><i class="fal fa-life-ring"></i></div>
                                Help Center
                            </a>
                        </div>
                    </div>
                </div>

                <div class="row mt-3 mb-2">
                    <div class="col text-center">
                        <span class="font-18">Or send us a message</span>
                    </div>
                </div>

                <div class="row pl-4 pr-4">
                    <div class="col">
                        <hr>
                        <div v-if="isSent" class="alert alert-success">Thank you, we will be in touch shortly.</div>
                        <div v-if="hasError" class="alert alert-danger">
                            Sorry, we are currently unable to send your suggestion.<br/>
                            We want to hear from you please try again or contact support.
                        </div>
                    </div>
                </div>

                <div class="row pl-4 pr-4 mt-2">
                    <div class="col">
                        <form>
                            <div class="form-group">
                                <textarea class="form-control" rows="4"
                                          :class="{'input': true, 'is-invalid': $v.form.message.$error  }"
                                          v-model.trim="form.message" @input="delayTouch($v.form.message)"
                                          placeholder="Get in touch, we'd love to hear from you"></textarea>

                                <span v-if="$v.form.message.$error" class="invalid-feedback form-text text-danger">
                                    <span v-if="!$v.form.message.required">Let us know what you think</span>
                                </span>
                            </div>
                            <a @click.prevent="submitSupportForm" href="" class="btn btn-primary btn-block">
                                <span v-show="isLoading">
                                    <i class="fas fa-spinner fa-pulse"></i>
                                </span>
                                <span v-show="!isLoading">Send Message</span>
                            </a>
                        </form>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="row mx-0 my-3 w-100">
                        <div @click="clearAppLocalStorageAndCache" class="col-6 align-self-center">
                            <span class="text-purple clickable font-16">
                                Clear local cache
                            </span>
                        </div>
                        <div class="col-6 text-right">
                            <span @click.prevent="closeModal" class="text-purple clickable font-18">
                                Close
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

import contact from '../../command/contact'
import CallBackModal from './callBack.vue'
import {required} from 'vuelidate/lib/validators'
import {clearAppLocalStorageAndCache} from '../../utils/app'

const touchMap = new WeakMap()

export default {
    data() {
        return {
            form: {
                message: ''
            },
            isLoading: false,
            isSent: false,
            hasError: false,
            errorCode: null,

            clearAppLocalStorageAndCache
        }
    },
    computed: {
        ...mapGetters([
            'isAdmin'
        ]),

        supportUrl() {
            return 'https://zudello9820.zendesk.com/hc/en-gb'
        },

        showGetDemoBtn() {
            return !this.isWebExpensesApp && this.isAdmin
        },

        showCallMeBtn() {
            return this.isAdmin
        }
    },
    validations: {
        form: {
            message: {
                required
            }
        }
    },
    methods: {
        delayTouch($v) {
            this.errorCode = null
            this.errorMsg = null
            this.hasError = false

            $v.$reset()
            if (touchMap.has($v)) {
                clearTimeout(touchMap.get($v))
            }
            touchMap.set($v, setTimeout($v.$touch, 1000))
        },

        submitSupportForm() {
            let self = this

            if (self.$v.$invalid) {
                self.$v.$touch()
                return
            }

            self.isLoading = true
            self.isSent = false
            self.hasError = false

            contact.support({body: this.form.message}).then(resp => {
                self.isLoading = false
                self.isSent = true
                self.form.message = ''
                self.$v.$reset()

                setTimeout(function() {
                    self.isSent = false
                }, 2500)
            }).catch(err => {
                self.isLoading = false
                self.hasError = true
                self.errorCode = err.statusCode
            })
        },

        openCallMe() {
            if (this.isWebExpensesApp) {
                window.open('https://www.webexpenses.com/contact/')
            } else {
                this.$emit('close')
                this.$modal.show(CallBackModal, {
                    iframe: 'https://calendly.com/zudello/call-back'
                }, {
                    width: '80%',
                    height: 'auto'
                })
            }
        },
        openGetADemo() {
            this.$emit('close')

            this.$modal.show(CallBackModal, {
                iframe: 'https://calendly.com/zudello/zudello-demo'
            }, {
                width: '80%',
                height: '700px'
            })
        },

        closeModal() {
            this.$emit('close')
        }
    }
}
</script>
